import { render, staticRenderFns } from "./_ad.vue?vue&type=template&id=f56c8896"
import script from "./_ad.vue?vue&type=script&lang=js"
export * from "./_ad.vue?vue&type=script&lang=js"
import style0 from "./_ad.vue?vue&type=style&index=0&id=f56c8896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports